module.exports = __webpack_public_path__ + "img/img06.21f9c0ea.jpeg";